'use client';

import { useRouter } from 'next/navigation';
import { ArrowLeft } from 'lucide-react';

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="min-h-screen bg-black text-white font-sans flex flex-col relative overflow-hidden">
      {/* Dynamic ambient backdrops */}
      <div className="absolute top-0 inset-x-0 h-[640px] bg-[url('/landing/images/hero.jpg')] bg-cover bg-center opacity-30 pointer-events-none" />
      <div className="absolute top-0 inset-x-0 h-[640px] bg-gradient-to-b from-black/60 via-black/90 to-black z-0 pointer-events-none" />

      {/* Standalone Brand Header */}
      <header className="relative z-10 pt-10 pb-6 text-center max-w-6xl mx-auto px-6 flex items-center justify-between w-full border-b border-white/5">
        <div className="flex items-center cursor-pointer" onClick={() => router.push('/')}>
          <img 
            src="/landing/logo.png" 
            alt="The Guest Club Logo" 
            className="h-9 md:h-11 w-auto object-contain" 
          />
        </div>
        <div className="flex items-center gap-4">
          <span className="text-[10px] font-black tracking-widest text-neutral-400 uppercase">Swiss Hosted</span>
          <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
        </div>
      </header>

      {/* Main Content */}
      <main className="relative z-10 flex-1 flex flex-col items-center justify-center max-w-3xl mx-auto px-6 py-16 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 bg-brand/10 border border-brand/30 rounded-full mb-8">
          <span className="text-[9px] font-black uppercase tracking-[0.2em] text-brand">Security & Preference Protection</span>
        </div>

        {/* Luxury Gold corner highlighted box for 404 */}
        <div className="max-w-md w-full mx-auto p-10 border border-brand/20 bg-white/[0.01] backdrop-blur-md rounded-none text-center relative overflow-hidden shadow-2xl mb-12">
          {/* Corner gold borders */}
          <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-brand" />
          <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-brand" />
          <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-brand" />
          <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-brand" />
          
          <h1 className="text-4xl font-serif text-white tracking-widest mb-4 font-light uppercase">404</h1>
          <div className="text-lg font-serif font-light tracking-widest text-white leading-relaxed uppercase mb-2">
            PAGE <span className="text-brand font-medium italic text-xl lowercase tracking-normal">not</span> FOUND
          </div>
          <p className="text-[9px] uppercase tracking-widest text-neutral-500 font-sans font-semibold mt-4">
            The requested preference pass or page is inaccessible, invalid, or has expired.
          </p>
        </div>

        <p className="text-neutral-400 text-sm max-w-md mb-8 leading-relaxed">
          The link you followed may be broken, or the guest sharing token has been revoked by its owner to protect their personal stay intelligence.
        </p>

        <button 
          onClick={() => router.push('/')}
          className="w-[240px] h-12 bg-brand border border-brand text-white hover:bg-brand/90 font-sans rounded-none font-bold uppercase tracking-[0.2em] text-[10px] transition-all duration-300 flex items-center justify-center gap-2 cursor-pointer shadow-lg shadow-brand/10"
        >
          <ArrowLeft className="w-3.5 h-3.5" /> Return to Portal
        </button>
      </main>

      <footer className="relative z-10 py-12 border-t border-white/5 text-center text-[9px] text-neutral-600 uppercase tracking-widest font-black w-full mt-auto">
        © 2026 The Guest Club. All Rights Reserved.
      </footer>
    </div>
  );
}
